<template>
  <div></div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Content } from '@forchange/storytime';

@Component
export default class CourseFinished extends Vue {
  @Prop({ type: Object }) content!: Content & { occured?: boolean };

  mounted() {
    if (window.storyteller.topContet?.$kind === 'CourseFinished') {
      window.next();
      this.$emit('loaded');
    }
  }
}
</script>
